import { WEB_URL } from '@/config/endpoints';
import Link from 'next/link';
import React from 'react';


const BreadCrumb = (props) => {
  return (
    <div className='container lg:px-3 px-3 xm:px-2 mt-2 sm:mt-4'>
        <ul className='flex text-xs items-center sm:items-start'>
          <li className='flex items-center'><Link className='text-brand hover:underline' href={WEB_URL}>Home</Link> <span><svg className='w-2 h-2' xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path></svg></span></li>
          <li className='flex items-center'><Link className='text-brand hover:underline' href={WEB_URL+'/'+props.parentSlug}>{props.parentPage} </Link> <span><svg className='w-2 h-2' xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path></svg></span></li>
          <li>{props.page}</li>
        </ul>
      </div>
  )
}

export default BreadCrumb